import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import './styles.scss'

interface IPopupModal {
  children: React.ReactNode
  setIsOpen: (value: boolean) => void
  isOpen: boolean
  header?: boolean
  className?: string
  closeButton?: boolean
  headerIcon?: string
  modalSize?: 'lg' | 'sm' | 'xl'
  isCloseOutside?: boolean
  footer?: boolean
  title?: string
}

const PopupModal = (props: IPopupModal) => {
  const {
    isOpen,
    children,
    header = false,
    setIsOpen,
    className,
    closeButton,
    modalSize,
    headerIcon,
    isCloseOutside = false,
    footer = false,
    title = '',
  } = props

  const { t } = useTranslation()

  return (
    <Modal
      className={className}
      show={isOpen}
      size={modalSize ? modalSize : 'lg'}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={isCloseOutside}
      onHide={() => setIsOpen(false)}
    >
      {header && (
        <Modal.Header closeButton={closeButton}>
          {headerIcon && (
            <div className="header-icon">
              <img src={headerIcon} alt="header-icon" />
            </div>
          )}
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
      {footer && (
        <Modal.Footer>
          <button className="btn-footer" onClick={() => setIsOpen(false)}>
            {t('common.ok')}
          </button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default PopupModal
